export const NAME = 'EthMigration';

export class EthMigrationError extends Error {
  constructor(message?: string) {
    super(message || NAME);
    this.name = NAME;
  }
}
